
import { Component, Vue, Prop } from "vue-property-decorator";
import { objAny } from "@/common/common-interface";
import {
  projectLicenceAdd,
  projectLicenceUpd,
  getLicenceModual
} from "@/api/api-basic";
import regular from "@/common/regular";
import i18n from "@/config/i18n";
@Component({
  components: {}
})
export default class PiAccountNumberAdd extends Vue {
  @Prop({ default: "" }) private subSystemId!: string;
  private modalShow = false;
  private title = i18n.t("cardClient.add");
  private itemData: objAny = {};

  private formInline: objAny = {
    beginTime: "",
    endTime: "",
    machineCode: "",
    modulePkIds: [],
    pileNumber: "",
    projectPkId: ""
  };
  private formObj: objAny = {};
  private ruleInline: objAny = {
    modulePkIds: [
      {
        required: true,
        trigger: "blur",
        validator: (rule: objAny, value: string) => {
          if (value.length == 0) {
            return new Error(i18n.t("cardClient.modulePkIdsPl") + "");
          }
          return true;
        }
      }
    ],
    machineCode: [
      {
        required: true,
        trigger: "blur",
        validator: (rule: objAny, value: string) => {
          if (!value) {
            return new Error(i18n.t("cardClient.machineCodePl") + "");
          }
          return true;
        }
      }
    ],
    // machineCode: [
    //   {
    //     required: true,
    //     trigger: "blur",
    //     validator: (rule: objAny, value: string) => {
    //       const reg = /^[1-9]\d*$/;
    //       if (!value) {
    //         return new Error("请输入序列号");
    //       } else if (value.length != 8 && value.length != 12) {
    //         return new Error("序列号只能是8位或12位数字");
    //       } else if (!reg.test(value)) {
    //         return new Error("序列号必须大于0的整数");
    //       }
    //       return true;
    //     }
    //   }
    // ],
    pileNumber: [
      {
        required: true,
        trigger: "blur",
        validator: regular.int,
        max: 5000,
        name: i18n.t("cardClient.pileNumber")
        //  (rule: objAny, value: string) => {
        //   const reg = /^[1-9]\d*$/;
        //   if (!value) {
        //     return new Error("请输入桩数量");
        //   } else if (Number(value) > 5000) {
        //     return new Error("一次性充值金额不能多于5000");
        //   } else if (!reg.test(value)) {
        //     return new Error("充值金额必须大于0的整数");
        //   }
        //   return true;
        // }
      }
    ],
    beginTime: [
      {
        required: true,
        message: i18n.t("cardClient.beginTimePl"),
        type: "date",
        trigger: "change"
      }
    ],
    endTime: [
      {
        required: true,
        message: i18n.t("cardClient.endTimePl"),
        type: "date",
        trigger: "change"
      }
    ]
  };
  private modalType = false;
  private projectLicensePkId = "";
  private licenceModualList: object[] = [];
  public open(type: string, projectPkId: string, item: objAny) {
    this.modalShow = true;
    this.formInline.projectPkId = projectPkId;

    if (type == "add") {
      this.modalType = false;
      this.title = i18n.t("cardClient.addLicence");
      this.formInline.projectPkId = projectPkId;
      this.formInline.beginTime = "";
      this.formInline.endTime = "";
      this.formInline.machineCode = "";
      this.formInline.modulePkIds = [];
      this.formInline.pileNumber = "";
    } else {
      console.log(item);

      this.modalType = true;
      this.title = i18n.t("cardClient.updataLicence");
      this.projectLicensePkId = item.projectLicensePkId;
      this.formInline.projectPkId = projectPkId;
      this.formInline.beginTime = new Date(item.beginTime);
      this.formInline.endTime = new Date(item.endTime);
      this.formInline.machineCode = item.machineCode;
      this.formInline.modulePkIds = item.modulePkIds;
      this.formInline.pileNumber = item.pileNumber;

      // item.modulePkIds.map((itemData: objAny) => {
      //   this.licenceModualList.push(itemData);
      // });

      // const licenceModualList: string[] = [];
      // item.modulePkIds.map((itemData: objAny) => {
      //   licenceModualList.push(itemData);
      // });
      // this.licenceModualList = licenceModualList;
    }
  }
  public handleSubmit() {
    const firstTime = this.$common.userDate(this.formInline.beginTime);
    const secondTime = this.$common.userDate(this.formInline.endTime);
    const beginTime =
      firstTime.split(" ")[0].split("-")[0] +
      firstTime.split(" ")[0].split("-")[1] +
      firstTime.split(" ")[0].split("-")[2];
    const endTime =
      secondTime.split(" ")[0].split("-")[0] +
      secondTime.split(" ")[0].split("-")[1] +
      secondTime.split(" ")[0].split("-")[2];
    if (beginTime > endTime) {
      this.$Message.error(i18n.t("cardClient.timeMax"));
      return;
    } else {
      this.formObj.validate((valid: boolean) => {
        if (valid) {
          this.submitData();
        }
      });
    }
  }
  async submitData(): Promise<void> {
    const firstTime = this.$common
      .userDate(this.formInline.beginTime)
      .split(" ")[0];
    const secondTime = this.$common
      .userDate(this.formInline.endTime)
      .split(" ")[0];
    let ret;
    if (!this.modalType) {
      const params = {
        beginTime: firstTime,
        endTime: secondTime,
        machineCode: this.formInline.machineCode,
        modulePkIds: this.formInline.modulePkIds,
        pileNumber: this.formInline.pileNumber,
        projectPkId: this.formInline.projectPkId
      };
      ret = await projectLicenceAdd(params);
      if (ret.status === this.$config.apiStatus) {
        this.$Message.success(i18n.t("addSuccess"));
        this.$emit("success");
        this.modalShow = false;
      }
    } else {
      const params = {
        beginTime: firstTime,
        endTime: secondTime,
        pileNumber: this.formInline.pileNumber,
        projectPkId: this.formInline.projectPkId,
        projectLicensePkId: this.projectLicensePkId
      };
      ret = await projectLicenceUpd(params);
      if (ret.status === this.$config.apiStatus) {
        this.$Message.success(i18n.t("updateSuccess"));
        this.$emit("success");
        this.modalShow = false;
      }
    }
  }
  public handleReset() {
    this.formObj.resetFields();
  }
  async getLicenceModual() {
    const ret = await getLicenceModual();
    if (ret.status === this.$config.apiStatus) {
      if (ret.data) {
        this.licenceModualList = ret.data;
      } else {
        this.licenceModualList = [];
      }
    }
  }
  mounted() {
    this.formObj = this.$refs["formValidate"];
    this.getLicenceModual();
  }
}
